import { customRequest } from "../../../../Common/modules/DataProvider/utils/DataProvider.utils";
import { checkIsStringEmpty } from "../../../../Common/modules/DataTypes/utils/strings";
import {
  fetch_sessions_list_api,
  fetch_sessions_metadata_api,
} from "../constants/Sessions.apis";
import { ISessions } from "../ISessions";

export const fetchSessions = ({
  searchText,
  startDate,
  endDate,
  listingUuid,
}: ISessions.IFetchSessionsProps) => {
  return customRequest<ISessions.IFetchSessionsResponse>({
    endpoint: fetch_sessions_list_api,
    payload: {
      ...(!checkIsStringEmpty(searchText) && { search_text: searchText }),
      start_date: startDate,
      end_date: endDate,
      listing_uuid: listingUuid,
    },
  });
};

// if listingUuid is not send it gives us start and end date for all sessions.
export const fetchSessionsMetaData = ({
  listingUuid,
  skip_customer_filter,
}: {
  listingUuid?: string;
  skip_customer_filter?: boolean;
}) => {
  return customRequest<ISessions.IFetchSessionsMetaDataResponse>({
    endpoint: fetch_sessions_metadata_api,
    payload: {
      listing_uuid: listingUuid,
      ...(skip_customer_filter !== undefined && { skip_customer_filter }),
    },
  });
};
